/** Max tools a teacher can pick during onboarding — matches dashboard pin limit. */
export const ONBOARDING_PRIORITY_SELECTION_MAX = 3;

export const teachingPrioritiesStepCopy = {
  title: "What would you like help with most?",
  subtitle:
    "Select the areas where ITEMA can best support your teaching journey. We'll tailor your workspace based on these priorities.",
  selectionHint: (count) =>
    count === 0
      ? `Choose ${ONBOARDING_PRIORITY_SELECTION_MAX} tools for your dashboard.`
      : `${count} of ${ONBOARDING_PRIORITY_SELECTION_MAX} selected`,
  backLabel: "Back",
  finishLabel: "Finish",
  savedMessage: "All selections saved automatically.",
};

/** Tool ids align with dashboard pinnable tools (`pinnableToolsCatalog`). */
export const teachingPriorityOptions = [
  { id: "teach-this-topic", label: "Teach This Topic" },
  { id: "explain-differently", label: "Explain Differently" },
  { id: "content-simplifier", label: "Content Simplifier" },
  { id: "quick-sheets", label: "Quick Sheets" },
  { id: "concept-questions", label: "Concept - Questions" },
  { id: "question-variations", label: "Question Variations" },
];

export const teachingPriorityCenteredOption = {
  id: "section-builder",
  label: "Section Builder",
};
